import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import Button from '../common/button/button';
import Form from './veiculoAlertaForm';

import { setModoTela, initForm, salvar, excluir } from './veiculoAlertaActions';
import DateFormat from '../common/dateFormat/DateFormat';

class VeiculoAlerta extends Component {

	state = {
		linhaSelecionada: null
	}

    componentWillMount() {

    }

    render() {
        return (
            <div>
                <Content>
					{this.props.modoTela == 'cadastro' ? (
						<Form onSubmit={this.props.salvar} />
					) : null}
					{this.props.modoTela == 'exclusao' ? (
						<Form excluir onSubmit={this.props.excluir} />
					) : null}
					{this.props.modoTela == 'lista' ? this.lista() : null}
                </Content>
            </div>
        )
    }

	lista() {
		return (
			<ContentCard>
				<ContentCardHeader>
					<Row>
						<Grid cols='6 6 4 2'>
							<Button
								text='Adicionar'
								type={'success'}
								icon={'fa fa-plus'}
								disabled={this.props.permissoes.acesso_logistica != 2}
								event={() => {
									this.props.setModoTela('cadastro', {});
									this.props.initForm({
										id_veiculo: this.props.id_veiculo
									});
								}} />
						</Grid>
					</Row>
				</ContentCardHeader>
				<ContentCardBody>
					<Table responsive>
						<THead>
							<Tr>
								<Th alignCenter>Início</Th>
								<Th alignCenter>Previsão</Th>
								<Th alignCenter>Fim</Th>
								<Th alignCenter>Descrição</Th>
								<Th></Th>
							</Tr>
						</THead>
						<TBody>
							{this.props.lista.filter(item => item.id_veiculo == this.props.id_veiculo).map(item => (
								<Tr key={item.id} className={`${this.state.linhaSelecionada == item.id ? 'hover' : ''}`}
									onClick={() => this.setState({ ...this.state, linhaSelecionada: item.id })}
									onMouseEnter={() => this.setState({ ...this.state, linhaSelecionada: item.id })} >
									<Td alignCenter>{DateFormat.formatarDataHoraSqlParaTela(item.datahora_inicio)}</Td>
									<Td alignCenter>{DateFormat.formatarDataHoraSqlParaTela(item.datahora_previsao)}</Td>
									<Td alignCenter>{DateFormat.formatarDataHoraSqlParaTela(item.datahora_fim)}</Td>
									<Td alignCenter>{item.descricao}</Td>
									<Td alignRight minWidth={150}>
										{!item.datahora_fim &&
										<ButtonTable
											type={'warning'}
											icon={'fas fa-pencil-alt'}
											visible={this.state.linhaSelecionada == item.id}
											event={() => {
												this.props.setModoTela('cadastro', {
													...item,
													datahora_inicio: DateFormat.formatarDataHoraSqlParaTela(item.datahora_inicio),
													datahora_previsao: DateFormat.formatarDataHoraSqlParaTela(item.datahora_previsao),
													datahora_fim: DateFormat.formatarDataHoraSqlParaTela(item.datahora_fim)
												});
												this.props.initForm({
													...item,
													datahora_inicio: DateFormat.formatarDataHoraSqlParaTela(item.datahora_inicio),
													datahora_previsao: DateFormat.formatarDataHoraSqlParaTela(item.datahora_previsao),
													datahora_fim: DateFormat.formatarDataHoraSqlParaTela(item.datahora_fim)
												});
											}} />}

										{!item.datahora_fim &&										
										<ButtonTable
											type={'success'}
											icon={'fas fa-check'}
											visible={this.state.linhaSelecionada == item.id}
											event={() => {
												this.props.salvar({
													...item,
													datahora_inicio: DateFormat.formatarDataHoraSqlParaTela(item.datahora_inicio),
													datahora_previsao: DateFormat.formatarDataHoraSqlParaTela(item.datahora_previsao),
													datahora_fim: DateFormat.formatarDataHoraSqlParaTela(DateFormat.getDataHoraAtual())
												});
											}} />}

										{!item.datahora_fim &&
										<ButtonTable
											type={'danger'}
											icon={'fas fa-trash-alt'}
											visible={this.state.linhaSelecionada == item.id}
											event={() => {
												this.props.setModoTela('exclusao', {
													...item,
													datahora_inicio: DateFormat.formatarDataHoraSqlParaTela(item.datahora_inicio),
													datahora_previsao: DateFormat.formatarDataHoraSqlParaTela(item.datahora_previsao),
													datahora_fim: DateFormat.formatarDataHoraSqlParaTela(item.datahora_fim)
												});
												this.props.initForm({
													...item,
													datahora_inicio: DateFormat.formatarDataHoraSqlParaTela(item.datahora_inicio),
													datahora_previsao: DateFormat.formatarDataHoraSqlParaTela(item.datahora_previsao),
													datahora_fim: DateFormat.formatarDataHoraSqlParaTela(item.datahora_fim)
												});
											}} />}
									</Td>
								</Tr>
							))}
						</TBody>
					</Table>
				</ContentCardBody>
			</ContentCard>
		);
	}


}

const mapStateToProps = state => ({
	sessao: state.auth.veiculoAlerta,
	modoTela: state.veiculoAlerta.modoTela,
	lista: state.veiculoAlerta.lista,
	permissoes: state.usuario.permissoes
});
const mapDispatchToProps = dispatch => bindActionCreators({ setModoTela, initForm, salvar, excluir }, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(VeiculoAlerta);
